import { Component, inject, input, TemplateRef } from '@angular/core';
import { RoundIconComponent } from '../round-icon/round-icon.component';
import { IconNameType } from '../icons/icon-name-type.enum';
import { AccentButtonComponent } from '../accent-button/accent-button.component';
import { AccentButtonStyleType } from '../accent-button/button-types.enum';
import { AccountCouponsService } from '../../core/services/account/account-coupons.service';
import { OrderService } from '../../core/services/order.service';
import { InitParamsService } from '../../core/services/init-params.service';
import { TranslocoDirective, TranslocoService } from '@ngneat/transloco';
import { ModalService, ModalName } from '../../core/services/modal.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'cwo-coupon-confirmation-modal',
    standalone: true,
    imports: [RoundIconComponent, AccentButtonComponent, TranslocoDirective],
    templateUrl: './coupon-confirmation-modal.component.html',
    styleUrl: './coupon-confirmation-modal.component.scss',
})
export class CouponConfirmationModalComponent {
    iconNameType = IconNameType;
    accentButtonStyleType = AccentButtonStyleType;
    couponConfirmationInstructionsModalTemplateRef = input<TemplateRef<any> | undefined>();

    modalService = inject(ModalService);
    accountCounponService = inject(AccountCouponsService);
    orderService = inject(OrderService);
    initParamsService = inject(InitParamsService);
    translocoService = inject(TranslocoService);

    handleInstruction() {
        this.closeModal().subscribe(() => {
            this.modalService.openGenericModal({
                modalTitle: this.translocoService.translate('modals.coupon_confirmation_modal.instructions_modal_title'),
                modalContent: this.couponConfirmationInstructionsModalTemplateRef(),
                confirmButtonText: this.translocoService.translate('modals.coupon_confirmation_modal.instructions_modal_confirm_button')
            });
        });
    }

    closeModal(): Observable<void> {
        return this.modalService.closeModal(ModalName.CouponConfirmation);
    }
}
